<template>
  <div class="wrapper">
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>H5接入</span>
        </div>
      </h3>
    </el-header>
    <el-scrollbar class="scrollbar-wrap">
      <div class="web-accesscode-box">
        <div class="bigfont">H5接入步骤（三步）</div>
        <div class="smallfont">1.点击以下按钮下载压缩包并上传到您的静态资源文件夹下（比如nignx配置转发地址），并解压</div>
        <div class="flowerbox">
          <div class="flower-linktxt">
            <a href="./home/files/xiaoi-h5.zip">
              <el-button type="primary" size="mini" style="margin-left:10px;">下载压缩包</el-button>
            </a>
          </div>
        </div>

        <div class="smallfont">2.将下面一段代码复制到 html/h5-XXX.html 中</div>
        <div class="flowerbox">
          <div class="flower-linktxt">
            <code class="code-color1">&lt;script</code>
            <code class="code-color2">&ensp;src=</code>
            <code class="code-color4">"{{scriptSrc}}"</code>
            <code class="code-color1">&gt;&lt;/script&gt;</code>
            <el-button type="primary" @click="copy()" size="mini" style="margin-left:10px;">一键复制</el-button>
          </div>
        </div>
        <div class="smallfont">3.通过url访问html文件夹下的h5-XXX.html即可</div>
        <el-row type="flex" justify="center">
          <el-button size="medium" @click="goBack">返回</el-button>
        </el-row>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'H5AccessCode',
  data() {
    return {
      objParam: ['userDims', 'userInfo']
    }
  },
  mounted() {
  },
  computed: {
    scriptSrc: function () {
      return this.$parent.accessScriptSrc
    }
  },
  methods: {
    // 返回
    goBack() {
      this.$parent.changeView('H5List')
    },
    // 复制参数
    copy() {
      const oInput = document.createElement('input')
      oInput.value = '<script src="' + this.$parent.accessScriptSrc + '"><' + '/script>'
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      oInput.remove()
      this.$message.success('复制成功!')
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 60px - 10px);
}
.el-header {
  /*height: auto !important;*/
  margin-bottom: 0;
  padding: 0;
  .title {
    /*margin-bottom: 20px;*/
  }
}

.web-accesscode-box {
  .bigfont {
    font-size: 18px;
    color: #333;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .smallfont {
    font-size: 12px;
    color: #666;
    line-height: 22px;
    margin-bottom: 10px;
  }

  .flowerbox {
    margin-bottom: 15px;
    .flower-linktxt {
      background-color: #f5f5f5;
      box-sizing: border-box;
      padding: 10px 15px;
      word-break: break-all;
      word-wrap: break-word;
      code {
        margin: 0;
        width: auto;
        text-align: left;
        font-size: 15px;
        font-family: "Microsoft YaHei";
      }

      .code-color1 {
        color: #09b8d8;
      }

      .code-color2 {
        color: #666;
      }

      .code-color3 {
        color: #18ba1f;
      }

      .code-color4 {
        color: #e96900;
      }

      div {
        line-height: 22px;
      }

      .props {
        margin: 0 20px;
      }
    }
  }

  .web-accesscodeinput {
    margin-top: 15px;
    ::v-deep .el-form-item {
      .el-form-item__label {
        font-size: 12px;
        color: #666;
      }
      .el-input {
        width: 260px;
        margin-right: 10px;
      }
    }
  }
}
</style>
